import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LayoutVrLearning, LayoutHome, LayoutAdminInmersys, LayoutAdminRoute, LayoutVRTraining } from "../layout";
import { TrainingDashboard, TrainingTable, TrinigAnalytics } from "../pages/VrTraining";
import { PrivatePath, PublicPath } from "./paths";
import { PrivateRouter } from "./PrivateRouter";
import { PublicRouter } from "./PublicRouter";
import { WebVersion } from "../components";
import { Home } from "../pages/Home";
import { LearningAnalytics, LearningDashboard, LearningTable, LearningTableUsers } from "../pages/VrLearning";
import { HomeInmersys } from "../pages/AdminInmersys";
import { onGetAdminInfo } from "../redux/auth/thunk";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { LoadingGeneral } from "../pages/common";
import { ViewerPdf } from "../pages/VrLearning/ViewerPdf";
import { TrainingHelp } from "../pages/VrTraining/TrainingHelp";

export const PrincipalRouter = () => {

    const dispatch = useDispatch()
    const [loadingData, setloadingData] = useState(true)

    useEffect(() => {
        const getInfoUser = async () => {
            // antes de tomar cualquier ruta verifica si hay token, si es asi llama al api para validarlo, y rellena la store 
            await dispatch(onGetAdminInfo())
            setloadingData(false)
        }
        getInfoUser()
    }, [dispatch])

    if (loadingData) {
        return <LoadingGeneral />
    }
    else {
        return (
            <main>
                <WebVersion />
                <BrowserRouter>
                    <Routes>
                        <Route
                            path="/*"
                            element={
                                <PrivateRouter>
                                    <Routes>
                                        <Route path={PrivatePath.home} element={<LayoutHome />}>
                                            <Route index element={<Home />} />
                                        </Route>
                                        <Route path={PrivatePath.vrTraining} >
                                            <Route path={PrivatePath.client} element={<LayoutVRTraining />}>
                                                <Route index element={<TrainingDashboard />} />
                                                <Route path={PrivatePath.dashboardVrl} element={<TrainingDashboard />} ></Route>
                                                <Route path={PrivatePath.tableVrl} element={<TrainingTable />} ></Route>
                                                <Route path={PrivatePath.analyticsVrl} element={<TrinigAnalytics />} ></Route>
                                                <Route path={PrivatePath.help} element={<TrainingHelp />} ></Route>
                                            </Route>
                                        </Route>
                                        <Route path={PrivatePath.vrLearning}>
                                            <Route path={PrivatePath.client} element={<LayoutVrLearning />}>
                                                <Route index element={<LearningDashboard />}></Route>
                                                <Route path={"help"} element={<ViewerPdf />}></Route>
                                                <Route path={PrivatePath.dashboardVrl} element={<LearningDashboard />} ></Route>
                                                <Route path={PrivatePath.tableUsers} element={<LearningTableUsers />}></Route>
                                                <Route path={PrivatePath.tableVrl} element={<LearningTable />} ></Route>
                                                <Route path={PrivatePath.analyticsVrl} element={<LearningAnalytics />} ></Route>
                                            </Route>
                                            <Route path={PrivatePath.inmersys} element={<LayoutAdminInmersys />}>
                                                <Route index element={<HomeInmersys />}></Route>
                                                <Route path={PrivatePath.proyectId} element={<LayoutAdminRoute />}>
                                                    <Route index element={<LearningDashboard />}></Route>
                                                    <Route path={PrivatePath.dashboardVrl} element={<LearningDashboard />}></Route>
                                                    <Route path={PrivatePath.tableVrl} element={<LearningTable />} ></Route>
                                                    <Route path={PrivatePath.analyticsVrl} element={<LearningAnalytics />} ></Route>
                                                </Route>
                                            </Route>
                                        </Route>
                                    </Routes>
                                </PrivateRouter>
                            }
                        />
                        <Route path={PublicPath.login} element={<PublicRouter />}></Route>
                    </Routes>
                </BrowserRouter>
            </main>
        );
    }
};
